import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-articleID", "innerHTML"]

import { ref, watch, onMounted } from 'vue';
import jsonp from '@/libs/api.request.js';
import { useContent } from '@/composables/useContent'
import useAnchor from '@/composables/useAnchor'


export default /*#__PURE__*/_defineComponent({
  props: ['articleID', 'parentID'],
  setup(__props) {

const props = __props



let { content, fetchContent, setArticleID, setparentID } = useContent(props.articleID, props.parentID)

useAnchor()
// onMounted(() => {
//   useAnchor()

//   if (props.articleID) {
//     fetchContent()
//   }
// })

watch(props, (nv, ov) => {
  setArticleID(nv.articleID);
  fetchContent()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    "data-articleID": _unref(props).articleID,
    innerHTML: _unref(content)
  }, null, 8, _hoisted_1))
}
}

})